import React from "react";
import highlightWiseMate from "../hooks/highlightWord";
import { renderHTML } from "../hooks/htmlToText";
import { BookButton } from "../ui/BookButton";
import { useTranslation } from "react-i18next";

export const Intro = () => {
  const { t } = useTranslation();
  return (
    <div className="self-center text-center">
      <div className="gap-[24px] md:gap-5-res flex flex-col mt-[64px] md:mt-[80px] lg:mt-[136px]">
        <p className="wrap-break-word text-primary-700 font-500 mx-[10%] text-[40px] md:mx-[0px] md:text-[52px] lg:text-[72px] leading-custom tracking-tighter font-sans self-center lg:max-w-[50%]">
          <span className="font-700">
            {String(t("homeIntroSection.title"))}
          </span>
          <br />
          {String(t("homeIntroSection.title2"))}
        </p>
        <p className="font-500 text-neutral-200 text-[18px] mx-[20px] md:mx-[0px] md:text-[24px] leading-[24px] md:leading-[32px] lg:w-[65%] self-center lg:max-w-[700px]">
          {highlightWiseMate(
            String(t("homeIntroSection.wiseIsTeam")),
            "font-700"
          )}
          <br className="hidden md:block" />
          {renderHTML(String(t("homeIntroSection.accessDatabase")))}
          <br />
          {String(t("homeIntroSection.withoutDelays"))}
        </p>
        <div className="mb-[64px] lg:mb-[75px]">
          <BookButton className="ml-onclick-form" />
        </div>
      </div>
      {/* <div className="gap-6-res flex flex-col animate-slideUpOvershoot">
        <p className="text-neutral-300 text-[12px] md:text-[13px] font-600 tracking-wider uppercase">
          {TITLES.TRUSTED_BY}
        </p>
        <div className="justify-between mx-[40px] md:mx-[0px] md:self-center text-center flex place-items-center gap-7-res mb-[40px] lg:mb-[27px] lg:w-[334px]">
          <ASSISTLogo />
          <div className="mb-3 md:mb-4">
            <FujitsuLogo />
          </div>
        </div>
      </div> */}
    </div>
  );
};
